import React from 'react'
import PageNotFound from '../../components/page_not_found'

const NotFoundPage = () => {
  return (
    <PageNotFound />
  )
}

export default NotFoundPage